export const APP_SELECT_SEGMENT = '/app-select'
